import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SaleDocket } from '../../models/sale-docket';
import { ConfigService } from '../../shared/services/config.service';
import { MomentModule } from 'ngx-moment';
import { UserIdToNamePipe } from '../../shared/pipes/user-id-to-name.pipe';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';
import { KeyValuePairComponent } from '../../shared/general/key-value-pair/key-value-pair.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgIf, AsyncPipe, TitleCasePipe } from '@angular/common';

@Component({
    selector: 'app-sales-docket-info',
    templateUrl: './sales-docket-info.component.html',
    standalone: true,
    imports: [NgIf, NgxSkeletonLoaderModule, KeyValuePairComponent, MatIconButton, MatTooltip, MatIcon, AsyncPipe, TitleCasePipe, UserIdToNamePipe, MomentModule]
})
export class SalesDocketInfoComponent {
  @Input() docket: SaleDocket;
  @Input() docketLoading: boolean;
  @Output() print = new EventEmitter<boolean>();
  @Output() email = new EventEmitter<void>();
  dateTimeFormat = ConfigService.dates.longDateTimeFormat;
}
